import { Box, Typography } from "@mui/material";
import { useEffect } from "react";

export const renderCell = (item, time) => {
  const formatTime = (date) => {
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });
    return formattedTime;
  };

  //Get service duration in minutes (converting from ms)
  const serviceDuration = (item.end - item.start) / 1000 / 60;

  return (
    <div
      className={`schedule-item`}
      style={{
        height: "100%",
        padding: "0px",
        display: "flex",
      }}
      data-start={formatTime(item.start)}
      data-end={formatTime(item.end)}
    >
      <div
        style={{
          width: "10px",
          minWidth: "10px",
          backgroundColor:
            item.services[0].service_color ||
            item.services[0].color ||
            item.color,
        }}
      ></div>
      <div
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "white",
          border: "1px solid black",
        }}
      >
        {time && (
          <Typography noWrap>
            {formatTime(item.start)} - {formatTime(item.end)}
          </Typography>
        )}
        {item?.services?.map((service, index) => (
          <div
            key={`${service.service_id}-${service.event_id}`}
            style={{
              padding: "2px 0px 2px 2px",
              gap: "4px",
              height: `$100%`,
              width: "100%",
              ...(serviceDuration <= 15 && {
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
              }),
            }}
          >
            {index === 0 && (
              <Typography
                sx={{
                  fontWeight: "800",
                  textTransform: "capitalize",
                  fontSize: 13,
                }}
                noWrap
              >
                {item.client?.client_name || ""}
              </Typography>
            )}
            {serviceDuration <= 15 && (
              <Typography sx={{ fontSize: 13 }} noWrap>
                -
              </Typography>
            )}
            <Typography sx={{ fontSize: 13 }} noWrap>
              {service.title}
            </Typography>
            {service.service_shortcut && (
              <Typography sx={{ fontSize: 12, textWrap: "nowrap" }}>
                ({service.service_shortcut})
              </Typography>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
